"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialShoppingPortalState = void 0;
const models_1 = require("../../../../models");
exports.initialShoppingPortalState = {
    customerId: '',
    deviceAttributes: models_1.DeviceType.Desktop,
    forwardedFor: '',
    forwardedHost: '',
    internalIpClass: '',
    locale: '',
    marketplaceId: '',
    pageNavNode: '',
    pageNavStore: '',
    pageNavTemplate: '',
    pageType: '',
    pageTypeId: '',
    requestId: '',
    sessionId: '',
    slateToken: '',
    ubid: '',
    deviceType: null,
    i18nPreferences: '',
    trafficPolicies: ''
};
